import React from "react";
import {ArenaFiltersConfigurationMap, IArenaViewModel} from "../arena-view-model.interface";
import {GameInfo} from "../../../../games/game-info";
import {IGamesFilterStrategy} from "../../../../games-filter/strategies/games-filter-strategy.interface";
import {NoGamesFilterStrategy} from "../../../../games-filter/strategies/no-filter/no-games-filter.strategy";
import {IServiceFactoryExtended} from "../../../../service-factory-extended.interface";

export class VoidArenaModel implements IArenaViewModel {
    constructor(private readonly services: IServiceFactoryExtended) {
    }
    get arenaName(): string {
        return 'voidArena';
    }

    get listsCount(): number {
        return 0;
    }

    renderArena(): React.ReactElement | null {
        return null;
    }

    renderList(listPosition: number): React.ReactElement | null {
        return null;
    }

    getNextBatchSize(currentListPosition: number): number {
        return 0;
    }

    filterGamesByArenaType(gamesInfo: GameInfo[]): GameInfo[] {
        return [];
    }

    readonly allArenaGamesForFiltering: GameInfo[] = [];

    readonly filteredGamesCount: number = 0;

    readonly filtersConfigurationMap: ArenaFiltersConfigurationMap = {};
    getGamesFilteringStrategy(): IGamesFilterStrategy {
        return new NoGamesFilterStrategy(this.services);
    }
}